import { OptionType } from './Filters'
import { InvestmentFilterItem } from '../../api/services/Api'


export const investmentFilterToOptionType = (investmentFilterItem: InvestmentFilterItem): OptionType => ({
  ...investmentFilterItem,
  value: investmentFilterItem.id || 'null',
})
